<script setup lang="ts">
defineProps<{
  episodes: PodcastRssEpisode[]
}>()
</script>

<template>
  <section>
    <ol v-if="episodes.length" v-auto-animate class="flex flex-col gap-2.5 lg:gap-xl">
      <PodcastEpisode
        v-for="(episode, i) in episodes"
        :key="episode.guid"
        :episode="episode"
        :class="{
          'lg:border-t lg:border-blurple-500 lg:pt-l': i > 0,
        }"
      />
    </ol>
    <!-- TODO: Add a message or component for when there are no episodes -->
  </section>
</template>
